var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Iconly/Bulk/Home"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Search",
    d: "M22.143 23.337l-.1-.081-3.6-3.507a11.157 11.157 0 01-6.9 2.369A10.946 10.946 0 01.5 11.31 10.946 10.946 0 0111.553.5a10.946 10.946 0 0111.054 10.81 10.638 10.638 0 01-2.911 7.3l3.555 3.466a.821.821 0 010 1.178.866.866 0 01-1.108.082zM2.2 11.31a9.259 9.259 0 009.35 9.144 9.26 9.26 0 009.35-9.144 9.26 9.26 0 00-9.351-9.144A9.259 9.259 0 002.2 11.31z"
  }))));
}

export default SvgSearch;